import { IMAGE_LOADING } from "./ApplicationConfig";

export default function loadIndicator(target: string|Element, hide: boolean = false)
{
    const CLASS_LOADING = 'load-indicator_loading';

    if (typeof target === 'string') {
        target = document.querySelector(target) as Element;
    }

    let node = target.querySelector('.js-load-indicator-node');

    if (hide) {
        node.parentElement.classList.remove(CLASS_LOADING);
    } else {
        if (node === null) {
            node = document.createElement('div');
            node.classList.add('js-load-indicator-node', 'load-indicator__icon');

            let img = document.createElement('img');
            img.src = IMAGE_LOADING;

            node.appendChild(img);
            target.appendChild(node);
        }

        node.parentElement.classList.add('load-indicator', CLASS_LOADING);
    }
}
